import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";
import shopify from "../../logo copy/shpify.png";

export default function Integrations() {
  const { t, isRTL } = useContext(LanguageContext);
  const integrations = t("integrations.items", { returnObjects: true }) || [];

  const logoMap = {
    Shopify: shopify,
    WooCommerce: "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/woocommerce.svg",
    Dropify: "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/dropbox.svg",
    PrestaShop: "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/prestashop.svg",
    Salla: "https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/shopware.svg",
    YouCan: "https://static-portal.youcan.shop/images/home_page_images_v2/logo.svg",
  };

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-4xl font-extrabold text-black">
            {t("integrations.title")}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {t("integrations.subtitle")}
          </p>
        </motion.div>

        {/* Grid */}
        <div className="mt-16 grid grid-cols-2 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {integrations.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className={`flex flex-col items-center justify-center rounded-2xl border border-gray-200 p-8 shadow-sm ${
                item.colored ? "bg-rose-50" : "bg-gray-50"
              }`}
            >
              {/* Special SVG for Zid */}
              {item.name === "Zid" ? (
                <svg
                  className="h-7 w-auto mb-4 text-gray-800"
                  viewBox="0 0 557 216"
                  fill="currentColor"
                >
                  {/* SVG paths unchanged */}
                </svg>
              ) : (
                <img
                  src={logoMap[item.name]}
                  alt={item.name}
                  className={`mb-4 h-12 w-12 object-contain ${
                    item.colored ? "" : "grayscale"
                  }`}
                />
              )}

              <span className="text-sm font-semibold text-gray-800">
                {item.name}
              </span>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
